import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetUser } from '@sib/api';
import { tracking } from '@sib/tracking';
import { Button } from '@sib/ui';
import { useLogout } from '@spendbrain/auth/hooks';
import { StarsIcon } from '@spendbrain/icons';
import { ActivateAiModal } from '..';
import { useAskAi } from '../hooks';
import { AskAiModal } from './AskAiModal';
import { LogoutButton } from './LogoutButton';
import { NavigationMenu } from './NavigationMenu';
import { UserWelcomeCard } from './UserWelcomeCard';

export const NavContent = () => {
  const { mutate: logout } = useLogout();
  const { data: identity } = useGetUser();
  const { t } = useTranslation();

  const {
    isAiModalOpen,
    isAskAiModalOpen,
    organization,
    handleAskAi,
    handleCloseAiModal,
    handleCloseAskAiModal,
  } = useAskAi();

  useEffect(() => {
    if (!identity) return;
    tracking.identifyUser(identity?.email, identity?.name);
  }, [identity]);

  return (
    <nav className="flex h-full flex-col border-r">
      <div className="flex items-center justify-center px-2">
        <UserWelcomeCard
          email={identity?.email || ''}
          name={identity?.name || ''}
          avatarUrl={identity?.avatarUrl || ''}
        />
      </div>

      <div className="flex items-center justify-center px-2 py-2">
        <Button variant="secondary" className="px-2" onClick={handleAskAi}>
          <span className="flex items-center gap-2">
            <StarsIcon className="h-5" />
            <span>{t('askSpendBrain')}</span>
          </span>
        </Button>
      </div>

      <div className="flex flex-1 flex-col justify-between overflow-x-hidden overflow-y-auto overscroll-contain">
        <div className="w-full pt-2">
          <NavigationMenu />
        </div>
        <div className="flex flex-col px-0.5 pb-10">
          <LogoutButton onLogout={logout} />
          <div className="flex w-full items-center justify-center py-5 pb-1">
            <p className="text-muted-foreground justify-center text-[10px]">
              {`${t('appName')} v${__APP_VERSION__}`}
            </p>
          </div>
        </div>
      </div>

      <ActivateAiModal
        isOpen={isAiModalOpen}
        onClose={handleCloseAiModal}
        organization={organization}
      />
      <AskAiModal isOpen={isAskAiModalOpen} onClose={handleCloseAskAiModal} />
    </nav>
  );
};
